<!-- <div class="content" *ngIf="isAuthorized && completeInit">
  <div class="content-header">
    <app-header></app-header>
  </div>
  <div class="content-main">
    <ng-container *ngTemplateOutlet="template"></ng-container>
  </div>
  <div class="content-footer">
    <app-footer></app-footer>
  </div>
</div> -->

<!-- <div class="content-landing" *ngIf="!isAuthorized && completeInit">
  <div class="content-header-landing clearfix">
    <app-header-landing-page></app-header-landing-page>
  </div>
  <div class="content-main-landing">
    <ng-container *ngTemplateOutlet="template"></ng-container>
  </div>
  <div class="content-footer-landing">
    <app-footer-landing-page></app-footer-landing-page>
  </div> 
</div> -->
<div [hidden]="!completeInit">
  <div [ngClass]="(isAuthorized && !isPreRegistration) ? 'content' : 'content-landing'">
    <div class="clearfix" [ngClass]="(isAuthorized && !isPreRegistration) ? 'content-header' : 'content-header-landing'">
     
      <app-header [hidden]="!isAuthorized || isPreRegistration"></app-header>          
       <!-- 注释 2021/3/23  -->   
       <app-header-landing-page [hidden]="isAuthorized && !isPreRegistration"></app-header-landing-page>
    </div>

    <!-- <marquee direction=left onMouseOut=start() onMouseOver=stop() scrollamount=2></marquee> -->
    <section *ngIf="showMarquee"  id="marquees" (mouseover)="stopAnimation()" (mouseleave)="startAnimation()">
      <span class="content" #marqueesContent> {{'PublicNote' | translate}}</span>
      <span (click)="closeMarquee()" class="close"></span>
    </section>

    <div [ngClass]="(isAuthorized && !isPreRegistration) ? 'content-main' : 'content-main-landing'" class="min-vh-100">
      <router-outlet></router-outlet>
    </div>
    <div [ngClass]="(isAuthorized && !isPreRegistration) ? 'content-footer' : 'content-footer-landing'">
      <app-footer [hidden]="!isAuthorized || isPreRegistration"></app-footer>
      <app-footer-landing-page [hidden]="isAuthorized && !isPreRegistration"></app-footer-landing-page>
    </div>
  </div>
</div>
<app-loader></app-loader>
<ng-template #preRegistrationModal let-c="close" let-d="dismiss">
  <div class="modal-body">
      <div class="row">
          <div class="col">
              <button class="close" type="button" (click)="d('Close')">
                <span>&times;</span>
              </button>
              <h4>{{ 'MessagePreRegistraionTitle' | translate }}</h4>
              <p>{{ 'MessagePreRegistraion1' | translate }} <a [attr.href]="redirectUrl">www.Pangjang.com</a> {{ 'MessagePreRegistraion2' | translate }} <span>{{ preRegistrationString }}</span> {{ 'MessagePreRegistraion3' | translate }}</p>
          </div>
      </div>
  </div>
</ng-template>
<ng-template #preRegistrationWelcomeModal let-c="close" let-d="dismiss">
  <div class="modal-body">
      <div class="row">
          <div class="col">
              <button class="close" type="button" (click)="d('Close')">
                <span>&times;</span>
              </button>
              <h4>{{ 'MessageWelcomePreRegistration' | translate }} <span>{{ preRegistrationString }}</span></h4>
          </div>
      </div>
  </div>
</ng-template>